import useArtistChatPageElement from '../../../hooks/artistChats/useArtistChatPageElement';

const ArtistChatPage = () => useArtistChatPageElement();

export default ArtistChatPage;
